// @flow
import * as Sentry from '@sentry/browser'

import { fetchServiceProvider } from '@alphaott/app-core/models/actions/appServiceProvider'
import { authMethods as fetchAuthMethods } from '@alphaott/app-auth/actions'
import type { BrandConfig } from '@alphaott/common-types'

import { fetchBrandConfig } from '../brand'
import { fetchConfig } from '../config'
import { getBrand } from '../../selectors'
import { BRAND_CONFIG_PATH } from '../../const'

export const INIT_MAIN_TYPE = 'main/INIT'
export const GEOBLOCKED_ERROR_TYPE = 'main/GEOBLOCKED_ERROR_TYPE'

export type InitOptions = {
  fetchBrandConfig?: boolean,
  brandConfigPath?: string,
  onBrandLoaded?: (brand: BrandConfig) => void,
  onError?: (err: mixed, message: string) => void,
}

const DefaultOptions: InitOptions = {
  fetchBrandConfig: true,
  brandConfigPath: '',
}

const defaultOnError = (err: mixed, message: string) => Sentry.captureException(err, { extra: { message } })

// eslint-disable-next-line complexity
const init = async (dispatch, getState, partialOptions: ?InitOptions) => {
  const options: InitOptions = { ...DefaultOptions, ...(partialOptions || {}) }
  const onError = options.onError || defaultOnError
  const { onBrandLoaded } = options

  try {
    if (options.fetchBrandConfig) {
      try {
        await dispatch(fetchBrandConfig(BRAND_CONFIG_PATH))
      } catch (err) {
        onError(err, "Brand_config couldn't be fetched")
        await dispatch(fetchBrandConfig())
      }
    }
  } finally {
    if (onBrandLoaded) {
      try {
        onBrandLoaded(getBrand(getState()))
      } catch (err) {
        onError(err, 'onBrandLoaded callback threw')
      }
    }
  }

  try {
    await dispatch(fetchConfig(options.brandConfigPath || ''))
  } catch (err) {
    onError(err, "Config with API endpoint couldn't be fetched")
    throw err
  }

  try {
    await dispatch(fetchServiceProvider())
  } catch (err) {
    onError(err, "Service Provider couldn't be fetched")
    throw err
  }

  try {
    await dispatch(fetchAuthMethods())
  } catch (err) {
    onError(err, "Auth Methods couldn't be fetched")
  }
}

export const initMain = (options?: InitOptions) => (dispatch: Function, getState: Function) =>
  dispatch({
    type: INIT_MAIN_TYPE,
    payload: init(dispatch, getState, options),
  })

export const geoBlockedError = (error: Object) => ({
  type: GEOBLOCKED_ERROR_TYPE,
  error,
})
